module.exports = __webpack_public_path__ + "static/media/image1.286ac19f.jpeg";